jQuery(function($) {
	var sort = require('tinysort');
	var items = document.querySelectorAll(".item");
	$(".id-label").clickToggle(function() {
		sort(items, {data:'id',order:'asc'});
	}, function() {
		sort(items, {data:'id',order:'desc'});
	});
	$(".desc-label").clickToggle(function() {   
		sort(items, {data:'desc',order:'asc'});
	}, function() {
		sort(items, {data:'desc',order:'desc'});
	});
});
jQuery.fn.clickToggle = function(a,b) {
	var ab = [b,a];
	return this.on("click", function(e){
		e.preventDefault();
		ab[this._tog^=1].call(this);
	});
};


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/pages/archive-orklaway-documents.js
// module id = 27
// module chunks = 0